import { PropsWithChildren } from 'react'

import styled, { css } from 'styled-components'

type ContainerProps = {
  isSelected?: boolean
  tileBackground?: string
}

export const TileContainer = styled.div<PropsWithChildren<ContainerProps>>`
  display: flex;
  flex-direction: row;
  align-items: stretch;

  ${({ theme, isSelected = false, tileBackground }) => css`
    background-color: ${isSelected ? theme.colors.selectable : tileBackground};
  `};
`
